import React from 'react';
import { projects, projectsSection } from './data/projects';
import useInView from '../hooks/useInView';

const Project = ({ project, lead }) => {
  const titleId = `project-${project.id}`;

  return (
    <article className={`project${lead ? ' project-lead' : ''}`} aria-labelledby={titleId}>
      <p className="project-meta">
        <span className="project-status">{project.status}</span>
        <span>{project.role}</span>
      </p>
      <h3 id={titleId} className="project-name">
        <a href={project.url} target="_blank" rel="noopener noreferrer">
          {project.name}
          <span className="visually-hidden"> (opens in a new tab)</span>
          <span aria-hidden="true"> ↗</span>
        </a>
      </h3>
      <p className="project-line">{project.oneLine}</p>
      <p className="project-description">{project.description}</p>
      <ul className="tag-list" aria-label={`Stack for ${project.name}`}>
        {project.stack.map((tag) => (
          <li className="tag" key={tag}>
            {tag}
          </li>
        ))}
      </ul>
    </article>
  );
};

const Projects = () => {
  const [ref, inView] = useInView();

  return (
    <section
      id="projects"
      aria-labelledby="projects-title"
      ref={ref}
      className={`section projects reveal${inView ? ' in-view' : ''}`}
    >
      <div className="container">
        <div className="section-head">
          <h2 id="projects-title" className="section-title">
            {projectsSection.title}
          </h2>
          <p className="section-intro">{projectsSection.intro}</p>
        </div>
        <div className="project-grid">
          {projects.map((project, index) => (
            <Project key={project.id} project={project} lead={index === 0} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default Projects;
